import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

export const fetchProducts = async (category) => {
  const { data } = await api.get("/products", { params: category ? { category } : {} });
  return data.products;
};

export const fetchProduct = async (idOrSlug) => {
  const { data } = await api.get(`/products/${idOrSlug}`);
  return data;
};

export const fetchCategories = async () => {
  const { data } = await api.get("/categories");
  return data.categories;
};

export const fetchReviews = async () => {
  const { data } = await api.get("/reviews");
  return data.reviews;
};

export const fetchFaqs = async () => {
  const { data } = await api.get("/faqs");
  return data.faqs;
};

export const submitQuiz = async (answers) => {
  const { data } = await api.post("/quiz/recommend", { answers });
  return data;
};

export const subscribeMonthly = async (payload) => {
  const { data } = await api.post("/subscriptions", payload);
  return data;
};

export const submitContact = async (payload) => {
  const { data } = await api.post("/contact", payload);
  return data;
};

export const newsletterSignup = async (email) => {
  const { data } = await api.post("/newsletter", { email });
  return data;
};

export const trackOrder = async (payload) => {
  const { data } = await api.post("/orders/track", payload);
  return data;
};
